

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class YearMonthPicker extends Vue {
  @Prop({ default: new Date().getFullYear() }) yearValue!: number;
  @Prop({ default: new Date().getMonth() + 1 }) monthValue!: number;
  @Prop({ default: "" }) keyProp?: string;

  async mounted() {
    document.addEventListener("click", this.handleClickOutside);
    await this.$store.dispatch("loadEstimates");
  }

  get serviceCreatedYear(): number {
    const estimates = this.$store.state.estimates || [];
    if (!estimates || estimates.length === 0) return new Date().getFullYear();

    const years = estimates
      .map((estimate: any) => {
        if (!estimate.projectContractDate) return null;
        const date = new Date(estimate.projectContractDate);

        if (isNaN(date.getTime())) return null;

        return date.getFullYear();
      })
      .filter((year: number | null): year is number => year !== null);

    if (years.length === 0) return new Date().getFullYear();
    const minYear = Math.min.apply(null, years);
    return minYear;
  }

  listMonth = Array.from({ length: 12 }, (_, i) => i + 1);

  get listYear(): number[] {
    const currentYear = new Date().getFullYear();
    const startYear = this.serviceCreatedYear;
    const length = currentYear - startYear + 1;

    return Array.from({ length }, (_, i) => startYear + i).sort(
      (a, b) => b - a
    );
  }

  updateMonth(value: number) {
    this.$emit("changedMonth", value, this.keyProp);
  }

  updateYear(value: number) {
    this.$emit("changedYear", value, this.keyProp);
  }

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event: Event) {
    this.$emit("handleClickOutside", event);
  }
}
